import _ from 'lodash';

export class Scenario {
    constructor(scen: any) {  
        scen = scen || {};
        if (!_.isEmpty(scen)) {
          this.id = scen.id;
          this.briefing = scen.briefing
          this.description = scen.description;
          this.detailedOverview = scen.detailedOverview;
          this.featured = scen.featured
          this.featuredImage = scen.featuredImage
          this.gameStartTime = scen.gameStartTime;
          this.gameTimeInterval = scen.gameTimeInterval;
          this.images = scen.images
          this.injects = scen.injects
          this.keywords = scen.keywords
          this.localImages = scen.localImages
          this.name = scen.name;
          this.numOfPlayers = scen.numOfPlayers;
          this.owner = scen.owner
          this.published = scen.published
          this.roles = scen.roles;
          this.sharedWith = scen.sharedWith
          this.snippets = scen.snippets
          this.tags = scen.tags;
          this.tagsDetails = scen.tagsDetails;
          this.tagsLocation = scen.tagsLocation;
          this.tagsTopic = scen.tagsTopic;
          this.v = scen.v;
          this.version = scen.version;
          this.votingStyle = scen.votingStyle; //(unanimous, majority)
        }
    }
    id: string = '';
    name: string = '';
    description: string = '';
    featured: boolean = false;
    featuredImage: string = '';
    version: string = '';
    detailedOverview: string = '';
    briefing: string = '';
    votingStyle: string = 'majority'; //(unanimous, majority)
    numOfPlayers: number = 0;
    roles: string[] = ['Inst', 'A-2', 'A-3'];
    images: string[] = [];
    keywords: string[] = []
    localImages: string[] = [];
    gameStartTime: Date = new Date();
    gameTimeInterval: number = 1;
    injects: ScheduledInjects[] = [];
    snippets: TurnBrief[] = [];
    tagsDetails: string[] = [];
    tagsLocation: string[] = [];
    tagsTopic: string[] = [];
    tags: string[] = [];
    owner: string = '';
    sharedWith: string[] = [];
    totalRoles: Role[] = [];
    firstSave: boolean = true;
    published: boolean = false;
    v: number = 2;
  }

  export class TurnBrief {
    turn: number = 1;
    briefingText: string = '';
    images: string[] = [];
  }

  export class Role {
    text: string = '';
    count: any = 0;
    order: number = 0;
  }

  export class ScheduledInjects {
    id: string = '';
    startTurn: number = 0;
    turnOrder: number = 0;
    injectId: string = '';
    name: string = '';
    description: string = '';
    length: number = 1;
    isNew: boolean = false;
    localImage: string = '';
  }

  export class NewInjectObj {
    id = '';
    injectId = '';
    turnLength = 1;
    name = 'New Inject'
    startTurn = 0; 
    turnOrder = 0;
    nodes = []
  }

 export class Inject {
    constructor(inj: any) {
      inj = inj || {};
      if (!_.isEmpty(inj)) {
        this.id = inj.id;
        this.injectId = inj.injectId;
        this.description = inj.description;
        this.owner = inj.owner;
        this.image = inj.image;
        this.localImage = inj.localImage;
        this.turnLength = inj.turnLength;
        this.name = inj.name;
        this.startTurn = inj.startTurn; 
        this.turnOrder = inj.turnOrder;
        this.nodes = inj.nodes;
        this.isNew = inj.isNew;
        this.published = inj.published;
        this.nextActionId = inj.nextActionId;
        this.v = inj.v;
      }
    }
    id: string = '';
    injectId: string = '';
    inject: any = {};
    image: string = '';
    localImage: string = '';
    imageUrl: string = '';
    global: boolean = false;
    public: boolean = true;
    published: boolean | undefined = undefined;
    turnLength: number = 1;
    nextActionId: number = 0;
    nodes: InjectNode[] = []
    owner: string = '';
    sharedWith: string[] = [];
    isSelected: string = '';
    name: string = '';
    description: string = '';
    editMode: string = ''; 
    hasCoa: string = '';
    turnOrder: number = 0;
    startTurn: number = 0;
    isEmpty: boolean = false;
    isNew: boolean = false;
    isChanged: boolean = false;
    v: number = 2;
  }

  export interface Tag {
    id: string;
    text: string;
  }

  export class InjectNode {
    id: string = '';
    description: string = '';
    descOpen: boolean = true;
    descEditOpen: boolean = false;
    descHeight: number = 40;
    coaOpen: boolean = true;
    coaEditOpen: boolean = false;
    rfiOpen: boolean = true;
    rfiEditOpen: boolean = false;
    infoOpen: boolean = false;
    infoEditOpen: boolean = false;
    ttlOpen: boolean = false;
    name: string = '';
    informationBriefs: RoleContent[] = [];
    coas: COA[] = [];
    rfis: RFI[] = [];
    hasCoa: string = '';
    turn: number = 1;
    isEditing: string = '';
    isHovering: boolean = false;
    x: number = 0;
    y: number = 0;
    isNew: boolean = false;
    timeToLive: TimeToLive | null = null;
    startTurn: number = 0;
    v: number = 2;
  }

  export class NewNode {
    id: string = '';
    name: string = '';
    turn: number = 0;
    description: string = '';
    informationBriefs: RoleContent[] = [];
    coas: COA | NewCOA[] = [];
    rfis: RFI[] = [];
    timeToLive: TimeToLive | null = null;
    startTurn: number = 0;
  }

  export class CreateNode {
    injectId: string = '';
    name: string = '';
    nodes: any[] = [];
  }

  export class COA {
    constructor(coa: any) {  
      coa = coa || {};
      if (!_.isEmpty(coa)) {
        this.id = coa.id || this.id;
        this.displayText = coa.displayText || this.displayText;
        this.nextNodeId = coa.nextNodeId || this.nextNodeId;
        this.x = coa.x || this.x;
        this.y = coa.y || this.y;
        this.isNew = coa.isNew || this.isNew;
        this.v = coa.v || this.v;
      }
    }
    id: number = 0;
    displayText: string = '';
    nextNodeId: string = '';
    x: number = 0;
    y: number = 0;
    isNew: boolean = false;
    v: number = 2;
  }

  export class NewCOA {
    id: number = 0;
    displayText: string = '';
    nextNodeId: string = '';
  }
  
  export class RFI {
    id: number = 0;
    displayText: string = '';
    roleContent: RoleContent[] = [];
    nextNodeId: string = '';
    isNew: boolean = false;
    v: number = 2;
  }

  export class RoleContent {
    role: string = '';
    displayText: string = '';
  }

  export class SelectedOption {
    constructor(so: any) {  
      so = so || {};
      if (!_.isEmpty(so)) {
        this.label = so.label;
        this.value = so.value;
      }
    }
    label: string = '';
    value: string = '';
  }

  export class Organization {
    id: string = '';
    orgName: string = '';
  }

  export class NewUserInfo {
    userID: string = "";
    firstName: string = "";
    lastName: string = "";
    rank: string = "";
    password: string = "";
    admin: boolean = false;
    orgId: string = "";
  }

  export class User {
    id: string;
    email: string;
    password?: string;
    passwordHash: string;
    firstName: string;
    lastName: string;
    rank: string;
    refreshToken: string;
    admin: boolean;
    orgId: string;
    selected?: string;
  
    constructor() {
      this.id = defaultUser.id;
      this.email = defaultUser.email;
      this.firstName = defaultUser.firstName;
      this.lastName = defaultUser.lastName;
      this.rank = defaultUser.rank;
      this.passwordHash = defaultUser.passwordHash;
      this.refreshToken = defaultUser.refreshToken;
      this.admin = defaultUser.admin;
      this.orgId = defaultUser.orgId;
    }
  
    /**
     * Creates a deep copy of the User object.
     *
     * @param {User} user The user object to clone.
     * @returns {User} A new instance of the User object with the same properties.
     */
    static clone(user: User): User {
      const clonedUser = new User();
      clonedUser.id = user.id;
      clonedUser.email = user.email;
      clonedUser.firstName = user.firstName;
      clonedUser.lastName = user.lastName;
      clonedUser.rank = user.rank;
      clonedUser.passwordHash = user.passwordHash;
      clonedUser.refreshToken = user.refreshToken;
      clonedUser.admin = user.admin;
      clonedUser.orgId = user.orgId;
      return clonedUser;
    }
  }

  export const defaultUser: User = {
    id: "",
    email: "",
    firstName: "",
    lastName: "",
    rank: "",
    passwordHash: "",
    refreshToken: "",
    admin: false,
    orgId: ""
};

export class VotingOption {
  id: string = '';
  displayText: string = '';
  nextNodeId: string = '';
  x: number = 0;
  y: number = 0;
}

export class GameStatus {
  gameId: string = '';
  scenarioId: string = '';
  name: string = '';
  scenarioName: string = '';
  images: string = '';
  localImages: string = '';
  isPrivate: boolean = false;
  gameStyle: string = '';
  completeDate: Date = new Date();
  lastWinner: LastWinner = new LastWinner()
  currentTurn: number = 0;
  currentTurnStatus: string = '';
  currentInjectId: number = 0;
  activeInjects: InjectInfo[] = [];
  finishedInjects: InjectInfo[] = [];
  rfis: RFIResult[] = [];
  password: string = '';
  host: string = '';
  players: Player[] = [];
  roles: string[] = [];
  moves: Move[] = [];
  started: boolean = false;
  completed: boolean = false;
  workingGroups: WorkingGroup[] = [];
  mainGroup: WorkingGroup = new WorkingGroup();
  hotwashSelection: number = 0;
  selected?: string;
}

export class LastWinner {
  type: string = '';
  choice: string = '';
  injectId?: string = '';
  injectName?: string = '';
  coaId?: string = '';
  coaName?: string = '';
  nodeId?: string = '';
  nodeName?: string = '';
}

export class RFIResult {
  injectId: number = 0;
  currentNodeId: string = '0';
  actionID: number = 0;
  turn: number = 0;
  roleContents: RoleContent[] = [];
  displayText: string = '';
  nextNodeId: string = '';
}

export class WorkingGroup {
  injectId: number = 0;
  playerIDs: string[] = [];
  status: string = '';
  moveHistory: Move[] = [];
  name?: string = '';
}

export class WorkingGroupVote {
  type: string = '';
  choice: string = '';
  reason: string = '';
  workingGroupOptions?: {
    injectId: string;
    players: string[];
  };
}

export class InjectVote {
  type: string = '';
  choice: string = '';
  reason: string = '';
  workingGroupOptions?: {
    injectId: string;
    players: string[];
  };
  actionOptions?: {
    injectId: string;
    choiceType: string; // "coa", "rfi", or "rfi (long)"
  };
  options?: {
    injectId: string;
    choiceType: string; // "coa", "rfi", or "rfi (long)"
  };
}

export class ActionVote {
  type: string = '';
  choice: string = '';
  reason: string = '';
  workingGroupOptions?: {
    players: string[];
  };
  actionOptions?: {
    injectId: string;
    choiceType: string; // "coa", "rfi", or "rfi (long)"
  };
}

export class StatusInjectInfo {
  injectId: string = '';
  name: string = '';
  startTurn: number = 0;
  currentNode: InjectNode = new InjectNode();
  workingGroupID: string = '';
  moveHistory: Move[] = [];
}

export class Node {
  id: string = '';
  description: string = '';
  coas: VotingOpt[] = [];
}

export class Game {
  constructor(scenarioId: string) {  
    scenarioId = scenarioId || '1';
    if (!_.isEmpty(scenarioId)) {
      this.scenarioId = scenarioId;
    }
  }
  id: string = '';
  gameId: string = '';
  scenarioId: string = '';
  password: string = '';
  started: boolean = false;
  completed: boolean = false;
  startDate: Date = new Date();
  completeDate: Date = new Date();
  host: string = '';
  roles: RoleContent[] = []
  gameStyle: string = '';
  votingType: string = '';
  players: Player[] = [];
  turns: Turn[] = [];
  rfis: RFIResult[] = [];
  activeInjects: InjectInfo[] = [];
  finishedInjects: InjectInfo[] = [];
  workingGroups: any[] = [];
  mainGroup: WorkingGroup = new WorkingGroup();
}

export class GameScenario {
  id: string = '';
  name: string = '';
  description: string = '';
  version: string = '';
  imagesPath: string = '';
  detailedOverview: string = '';
  briefing: string = '';
  votingStyle: string = '';
  numOfPlayers: number = 1;
  roles: string[] = [];
  gameStartTime: Date = new Date();
  gameTimeInterval: number = 1;
  injects: GameScheduledInject[] = [];
  tagsLocation: string[] = [];
  tagsDetails: string[] = [];
  tagsTopic: string[] = [];
}

export class LobbyStatus {
  gameId: string = '';
  scenario: any = {};
  players: Player[] = [];
  host: string = '';
}

export class GameScheduledInject {
  id: string = '';
  injectId: string = '';
  startTurn: number = 0;
  turnLength: number = 1;
  timeToLive: TimeToLive | null = null;
}

export class GameInject {
  id: string = '';
  gameTimeProgression: number = 1;
  rfiQuestions: string[] = [];
  gameEvents: GameEvent[] = [];
}

export class GameEvent {
  id: string = '';
  content: EventContent[] = [];
  options: VotingOpt[] = [];
}

export class VotingOpt {
  displayText: string = '';
  nextGameEventId: string = '';
  endsInject: boolean = false;
}

export class EventContent {
  role: string = '';
  displayText: string = '';
}

export class Player {
  userID: string = '';
  firstName: string = '';
  lastName: string = '';
  role: string = '';
  ready: boolean = false;
  orgId: string = '';
  rank: string = 'Unknown';
}

export class InjectInfo {
  id: number = 0;
  injectId: string = '';
  name: string = '';
  description: string = '';
  startTurn: number = 0;
  currentNode: InjectNode = new InjectNode();
  workingGroupID: string = '';
  moveHistory: Move[] = [];
  nodes: InjectNode[] = [];
  turnLength: number = 1;
  turnOrder?: number = 0;
  isSelected: string = '';
  localImage?: string = '';
  noCoas?: boolean = false;
}

export class Turn {
  status: string = '';
  completeTime: Date = new Date();
  moves: Move[] = [];
  result: string = '';
}

export class Move {
  id: string = '';
  type: string = '';
  turn: number = 0;
  player: string = '';
  choice: string = '';
  time: Date = new Date();
  comment: string = '';
  response: string = '';
  options: any = {};
  injectId: string = '';
}

export type DefaultMoveOptions = Record<string, never>;

/**
 * The options for an inject move.
 */
export type MemberSelectionMoveOptions = {
  injectID: string,
  players: string[];
};

/**
 * The options for an action move.
 */
export type ActionMoveOptions = {
  choiceType: string   // "coa", "rfi", or "rfi (long)"
  injectID: string,
};

/**
 * The options for a move.
 */
export type MoveOptions = DefaultMoveOptions | MemberSelectionMoveOptions | ActionMoveOptions;

export class Hotwash {
  /**
   * The unique identifier for the game.
   */
  gameId: string = '';

  /**
   * The ID of the associated scenario.
   */
  scenarioId: string = '';

  /**
   * The host of the game.
   */
  hostId: string = '';

  /**
   * An array of comments and timestamps for the After Action Review and Comment (AARC).
   */
  aarc: AARC[] = [];

  /**
   * The current selection of the hotwash.
   */
  currentSelection: HostSelection = new HostSelection();
}

export class HostSelection {
  /**
   * The current page of the hotwash.
   */
  page: string = '';

  /**
   * The current turn of the hotwash.
   */
  turn: number = 0;

  /**
   * The current inject of the hotwash.
   */
  inject: number = -1;

  /**
   * The current node of the hotwash.
   */
  node: string = '';

  /**
   * The current node tab of the hotwash.
   */
  nodeTab: string = '';

  /**
   * The current node player ID of the hotwash.
   */
  nodePlayerID: string = '';

  nodeTurn: number = 1;
}

export class NewHostSelection {
  hotwashId: string = '';
  hostSelection: HostSelection = new HostSelection();
  constructor (gameId?: string) {
    if (gameId) {
      this.hotwashId = gameId;
    }
  }
}

export class AARC{
  /**
   * The ID of the user who made the comment.
   */
  userId: string = '';

  /**
   * The comment.
   */
  comment: string = '';

  /**
   * The timestamp of the comment.
   */
  timestamp: Date = new Date();

}

export class TimeToLive {
  /**
   * The ID of the TimeToLive.
   */
  id: number = 0;

  /** 
   * The number of turns the node can last without failing the inject.
   */
  turns: number = 1;

  /**
   * The ID of the next InjectNode if this inject is not completed in time.
   */
  nextNodeId: string = '';
  x: number = 0;
  y: number = 0;
}

export class InjInfo {
  /**
   * The unique identifier for the inject.
   */
  id?: string = '';
  injectId?: string = '';
  /**
   * The name of the inject.
   */
  name?: string = '';

  /**
   * Whether the inject shows up on the global inject list.
   */
  global?: boolean = false;

  localImage?: string = '';
  /**
   * List of the inject's sharedWith users.
   */
  sharedWith?: Array<string> = [];

  /**
   * List of the inject's tags.
   */
  tags?: Array<string> = [];
}

export class LastSave {
  scenario: Scenario = new Scenario({});
  
  injects: Inject[] = [];

  scheduledInjects: ScheduledInjects[] = [];

  snippets: TurnBrief[] = [];

  nodes: NodeSave[] = [];
}

export class NodeSave {
  id: string = '';

  nodes: InjectNode[] = []
}